import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { useForm } from "react-hook-form";

import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Col, Row } from "react-bootstrap";
import Datepicker from "../../common/Datepicker";
import { formatDate } from "../../../utils/common";
import ExportMethod from "../../../utils/apis/ExportMethod";
import { getFundData, getFundsData, getProfitData, getRefferalData } from "../../../utils/apis/Report/Report";
import { ShimmerThumbnail } from "react-shimmer-effects";
library.add(fas);

// *****************************************************************************************************

const FundManage = () => {
  const { handleSubmit, getValues, reset, setValue } = useForm({
    defaultValues: {
      from: "",
      to: "",
      service_number: "",
    },
  });

  const onSubmit = async (data) => {
    getData();
  };

  const { shimmerLoader, setShimmerLoader } = useContext(Context);

  const [data, setData] = useState([]);

  const getData = async () => {
    setShimmerLoader(true);
    const res = await getFundData(getValues("from"), getValues("to"));
    await setData(res.data);
    
    setShimmerLoader(false);
  };

  useEffect(() => {
    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleExportFunds = async () => {
    const res = await getFundsData(getValues("from"), getValues("to"));

    const header = [
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Fund Type" },
      { name: "UTR ID" },
      { name: "Amount" },
    ];

    
    // Use map without async, but await promises
    const exportData = await Promise.all(
      res?.data?.total_fund_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const type = value?.type;
        const utrId = value?.utr_id;
        const amount = value?.amount;

        return [formattedDate, investorName, contact_no,type, utrId, amount];
      })
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Funds Report"
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportTrade = async () => {

    const header = [
      { name: "Earning Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Segment" },
      { name: "Earning Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      data?.total_fund_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const utrId = value?.utr_id;
        const amount = value?.amount;

        return [formattedDate, investorName, contact_no, utrId, amount];
      })
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Investor Ledger"
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportRefferal = async () => {

    const res = await getRefferalData(getValues("from"), getValues("to"));
    const header = [
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Referral Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      res?.data?.total_refferal_earning_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const amount = value?.t_c;

        return [formattedDate, investorName, contact_no, amount];
      })
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Referral Report"
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  const handleExportProfit = async () => {

    const res = await getProfitData(getValues("from"), getValues("to"));
    const header = [
      { name: "Payment Date" },
      { name: "Investor Name" },
      { name: "Service No" },
      { name: "Type" },
      { name: "PnL Amount" },
    ];

    // Use map without async, but await promises
    const exportData = await Promise.all(
      res?.data?.total_profit_distribution_data?.map((value) => {
        const formattedDate = formatDate(value.createdAt);
        const investorName = value?.user?.f_name + " " + value?.user?.l_name;
        const contact_no = value?.user?.contact_no;
        const type = value?.type;
        const amount = type === 'Profit' ? value?.t_c : value?.t_d;

        return [formattedDate, investorName, contact_no, type, amount];
      })
    );
    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Profit Report"
    );
    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };

  return (
    <>
      <div className="search-investor ">
        <p className="sub">Fund Management</p>
        <Row className="mt-3">
          <Col xxl={3} xl={3} lg={4}>
            <Datepicker
              reset={reset}
              getValues={getValues}
              setValue={setValue}
              className="mt-3"
            />
            <div className="d-flex">
              <div className="search" onClick={handleSubmit(onSubmit)}>
                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                <p>Search</p>
              </div>
              <div
                className="search ms-1"
                onClick={() => {
                  reset();
                  getData();
                }}
              >
                <p>Reset</p>
              </div>
            </div>
          </Col>
          <Col xxl={9} xl={9} lg={12}>
            <div className="search-transaction mt-3">
              <Row>
                <Col xxl={4} xl={4} lg={4}>
                  {shimmerLoader ? (
                    <>
                      <ShimmerThumbnail height={70} width={350} rounded />
                    </>
                  ) : (
                    <div className="main-inves">
                      <div className="">
                        <div>
                          <b>Total Available Fund</b>
                          <a
                            href="#!"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              handleExportFunds();
                            }}
                          >
                            <p>{data?.total_fund_users || 0}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
                <Col xxl={4} xl={4} lg={4}>
                  {shimmerLoader ? (
                    <>
                      <ShimmerThumbnail height={70} width={350} rounded />
                    </>
                  ) : (
                    <div className="main-inves">
                      <div className="">
                        <div>
                          <b>Till Date Trade Earning</b>
                          <a
                            href="#!"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              handleExportTrade();
                            }}
                          >
                            <p>{data?.total_trade_earning || 0}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
                <Col xxl={4} xl={4} lg={4}>
                  {shimmerLoader ? (
                    <>
                      <ShimmerThumbnail height={70} width={350} rounded />
                    </>
                  ) : (
                    <div className="main-inves">
                      <div className="">
                        <div>
                          <b>Till Date Referral Earning</b>
                          <a
                            href="#!"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              handleExportRefferal();
                            }}
                          >
                            <p>{data?.total_refferal_earning || 0}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
                <Col xxl={4} xl={4} lg={4}>
                  {shimmerLoader ? (
                    <>
                      <ShimmerThumbnail height={70} width={350} rounded />
                    </>
                  ) : (
                    <div className="main-inves">
                      <div className="">
                        <div>
                          <b>Till Date Profit Distribution</b>
                          <a
                            href="#!"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              handleExportProfit();
                            }}
                          >
                            <p>{data?.total_profit_distribution || 0}</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FundManage;
